import React from 'react';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { ErrorPageTypes } from '../../../../types/index';
import GetFreeQuotes from './GetFreeQuotes';
import ErrorImage from './images/empty-search-results.png';
import './index.scss';

const OopsPage = ({ errorContext }) => {
    const { username } = errorContext;

    return (
        <div className={classNames('error-page', 'max-width-container', 'oops-page')}>
            <div className="error-image">
                <img src={ErrorImage} alt="empty result image"/>
                <small><I18n k={'search_perseus.error_page.made_on_fiverr'} parseMarkup/> <b>onekaa</b></small>
            </div>
            <h2>
                <I18n k={'search_perseus.error_page.oops_page.title'}/>
            </h2>
            <p><I18n k={'search_perseus.error_page.oops_page.quotes_explain'}/></p>
            <GetFreeQuotes username={username}/>
        </div>
    );
};

OopsPage.propTypes = ErrorPageTypes;

export default OopsPage;
